export enum ResultDeterminationType {
    noResult,
    byContainer,
    byProductBox,
    byAmount,
    byAmountAndProductBox,
    byOneContainer,
    ByContainerAndProductBox,
}
